import { useEffect, useState } from 'react';

import { WebSocketStatusEnum } from '../../enums/WebSocketStatusEnum';
import {
  getWebSocketConnectionStatus,
  subscribeWebSocketConnectionStatus,
} from '../../utils/webSocketConnectionStatus';

/**
 * Live EventHub SignalR connection status for UI indicators.
 */
export function useWebSocketConnectionStatus(): WebSocketStatusEnum {
  const [status, setStatus] = useState<WebSocketStatusEnum>(() => getWebSocketConnectionStatus());

  useEffect(() => subscribeWebSocketConnectionStatus(setStatus), []);

  return status;
}
